import { ServiceTokens } from "$src/domain/ServiceTokens";
import { Customer } from "$src/domain/customers/Customer";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class CheckCustomerHasInvoices {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository) {}

    async execute(groupStoreId: number, customerId: number): Promise<boolean> {
        return this.customerRepository.hasInvoices(groupStoreId, customerId);
    }
}

export const CheckCustomerHasInvoicesToken = Symbol('CheckCustomerHasInvoicesToken');    

